var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e91e63;}.b{fill:#00bcd4;}.c{fill:#4caf50;}.d{fill:#ff9800;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.002 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.712,12.651a14.392,14.392,0,0,0-14.39,14.39v36a14.39,14.39,0,0,0,28.78,0v-36a14.4,14.4,0,0,0-14.39-14.39Z",
    transform: "translate(29.424 58.573)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.019,27.05a14.4,14.4,0,0,0,28.8,0v-14.4H14.42a14.4,14.4,0,0,0-14.4,14.4Z",
    transform: "translate(0.08 58.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.739,0h-.017a14.4,14.4,0,0,0,0,28.8h14.39V14.372A14.378,14.378,0,0,0,20.739,0Z",
    transform: "translate(29.414 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.4,35.127H50.467a14.4,14.4,0,0,0,0-28.8H14.4a14.4,14.4,0,0,0,0,28.8Z",
    transform: "translate(0 29.447)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M33.312,6.323A14.37,14.37,0,0,0,18.939,20.7v14.43h14.39a14.4,14.4,0,1,0,0-28.8Z",
    transform: "translate(88.163 29.442)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M12.641,14.391v36.1a14.39,14.39,0,0,0,28.78,0v-36.1a14.39,14.39,0,0,0-28.78,0Z",
    transform: "translate(58.843 0.009)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.135 71.212)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M41.42,33.345a14.392,14.392,0,0,0-14.39-14.39H12.64v14.4a14.39,14.39,0,0,0,28.78-.011Z",
    transform: "translate(-12.629 17.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M63.1,12.649H27.039a14.4,14.4,0,0,0,0,28.8H63.1a14.4,14.4,0,0,0,0-28.8Z",
    transform: "translate(-12.638 -12.649)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackIcon);
export default __webpack_public_path__ + "static/media/slack_icon.24e99b7c6745ccfc149db05a3b8c7618.svg";
export { ForwardRef as ReactComponent };